
import Vue from "vue";
import { NewSensorsApiFunc, setAccessToken } from "@/api";
import { Sensor, SensorStatus } from "@/models";

import TheTemplate from "../components/TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import moment from "moment";
import BaseChuiGaki from "@/components/BaseChuiGaki.vue";

export type DataType = {
  sensor?: Sensor;
};

export default Vue.extend({
  name: "SensorDeleteScreen",

  components: {
    BaseChuiGaki,
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      sensor: new Sensor(),
    };
  },

  computed: {
    companyNameText(): string {
      return this.$globalData.companyName || "";
    },

    sensorMacAddressText(): string {
      return this.sensor?.mac || "";
    },

    sensorTypeText(): string {
      const type = this.sensor?.sensorType;
        if (type === 'door-v1') return 'ドアセンサ-V1'
        if (type === 'door-v2') return 'ドアセンサ-V2'
        if (type === 'door-r1') return 'ドアセンサ-R1'
        if (type === 'infrared-v1') return '人感センサ-V1'
        if (type === 'infrared-r1') return '人感センサ-R1'
        if (type === 'distance') return '距離センサ'
        if (type === 'mic') return '新 MIC'
        if (type === 'thermopile') return 'サーモセンサー'
      return '不明';
    },

    batteryText(): string {
      const battery = this.sensor?.details?.battery
      if (!battery) {
        return ''
      }
      if (battery <= 20) {
        return 'Low'
      }
      if (battery <= 40) {
        return 'Low'
      }
      return 'High'
    },

    batteryClassText(): string {
      const battery = this.sensor?.details?.battery;
      if (!battery) {
        return "";
      }
      if (battery <= 18) {
        return "battery-red";
      }
      if (battery <= 30) {
        return "battery-orange";
      }
      return "battery-green";
    },

    sensorStatusText(): string {
      switch (this.sensor?.details?.status) {
        case SensorStatus.UNINITIALIZED:
          return "未初期化";
        case SensorStatus.RUNNING:
          return "稼動";
        case SensorStatus.SUSPENDED:
          return "停止";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.sensor?.details?.status) {
        case SensorStatus.UNINITIALIZED:
          return "red";
        case SensorStatus.RUNNING:
          return "";
        case SensorStatus.SUSPENDED:
          return "red";
        default:
          return "red";
      }
    },

    checkedTimingText(): string {
      if (!this.sensor?.details?.latestDateTime) return "なし";
      return moment(this.sensor?.details?.latestDateTime).format(
        "YYYY-MM-DD(HH:mm:ss)"
      );
    },
  },

  mounted() {
    this.getSensor();
  },

  methods: {
    async getSensor(): Promise<void> {
      const companyId = this.$router.currentRoute.params.companyId;
      const sensorId = this.$router.currentRoute.params.sensorId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewSensorsApiFunc().adminGetSensor(
        companyId,
        sensorId
      );

      if (err != null) {
        this.$handleApiError(err, this.getSensor);
        return;
      }

      this.sensor = data;
    },

    async unassignSensor(): Promise<void> {
      this.$setLoading(true);

      const companyId = this.$router.currentRoute.params.companyId;
      const sensorId = this.$router.currentRoute.params.sensorId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewSensorsApiFunc().adminUnassignSensor(
        companyId,
        sensorId
      );

      if (err != null) {
        this.$handleApiError(err, this.unassignSensor);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-sensors",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
